module.exports = __webpack_public_path__ + "img/youtube.568cbc76.svg";